import React, { useEffect, useState } from "react";
import { Form, Offcanvas, Table } from "react-bootstrap";
import { cdiscServices } from "../../../../Services/CDISC/cdiscServices";

const TemplateColumnProperties = ({
  Show,
  Hide,
  Title,
  tableRef,
  onMouseDown,
  studyId,
  uniqueId,
  dataEntry
}) => {
  const [studyDataTemplateColumn, setStudyDataTemplateColumn] = useState([]);
  const [checkboxValues, setCheckboxValues] = useState([]);
  const getStudyDataTemplateEntryData = async (studyId, uniqueId) => {
    let data = await cdiscServices.getStudyDataTemplateEntryData(
      studyId,
      uniqueId
    );
    setStudyDataTemplateColumn(data?.columns || []);
    setCheckboxValues(data?.showColumn || []);
  };

  const handleSelectAllCheckboxes = (e) => {
    const isChecked = e.target.checked;
    const updatedCheckboxValues = isChecked
      ? studyDataTemplateColumn.map((item) => item.name)
      : [];

    setCheckboxValues(updatedCheckboxValues);

    const updatedForms = studyDataTemplateColumn.map((item) => ({
      ...item,
      isChecked,
    }));

    setStudyDataTemplateColumn(updatedForms);
  };

  const handleCheckboxChange = (name, isChecked) => {
    const updatedCheckboxValues = isChecked
      ? [...checkboxValues, name]
      : checkboxValues.filter((item) => item !== name);

    setCheckboxValues(updatedCheckboxValues);

    const updatedForms = studyDataTemplateColumn.map((item) =>
      item.name === name ? { ...item, isChecked } : item
    );

    setStudyDataTemplateColumn(updatedForms);
  };

  let hideTableProperties = (checkboxValues?.length === 0 || checkboxValues?.length === undefined) ? [] : checkboxValues

  const updateStudyDataEntryData = async () => {
    let userData = {}
    userData.uniqueId = uniqueId
    userData.studyId = studyId
    userData.showColumn = checkboxValues
    let data = await cdiscServices.updateStudyDataEntryData(userData)
    if (data?.statusCode === 200) {
      getStudyDataTemplateEntryData(studyId, uniqueId)
      dataEntry(studyId, uniqueId)
      Hide()
    }
  }

  useEffect(() => {
    getStudyDataTemplateEntryData(studyId, uniqueId);
  }, [studyId, uniqueId]);

  return (
    <>
      <Offcanvas show={Show} onHide={Hide} placement="end" style={{ width: 550 }}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>{Title}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="p-0">
          <div
            className="overflow-auto"
            style={{ height: "calc(100vh - 89px)" }}
          >
            <Table
              ref={tableRef}
              id="resizable-table"
              className="text-nowrap custom-table"
              hover
              bordered
              striped
            >
              <thead className="thead-sticky z-1" style={{ top: -1 }}>
                <tr>
                  <th className="text-center" onMouseDown={(e) => onMouseDown(e, 0)} style={{ width: 40 }}>
                    <Form.Check
                      type="checkbox"
                      onChange={(e) => handleSelectAllCheckboxes(e)}
                      checked={
                        studyDataTemplateColumn?.length === 0 ? false : (hideTableProperties?.length === studyDataTemplateColumn?.length)
                      }
                    />
                  </th>
                  <th onMouseDown={(e) => onMouseDown(e, 1)}>Name</th>
                  <th onMouseDown={(e) => onMouseDown(e, 2)}>Label</th>
                  <th onMouseDown={(e) => onMouseDown(e, 3)}>Type</th>
                  <th onMouseDown={(e) => onMouseDown(e, 4)}>
                    Permission
                  </th>
                </tr>
              </thead>
              <tbody>
                {studyDataTemplateColumn?.map((item, index) => (
                  <tr
                    key={index}
                    className={`position-relative cursor-pointer`}
                  >
                    <td className="text-center">
                      <Form.Check type="checkbox"
                        name={item?.name}
                        id={item?.name}
                        checked={hideTableProperties?.includes(
                          item?.name
                        )}
                        onChange={(e) =>
                          handleCheckboxChange(
                            e.target.name,
                            e.target.checked
                          )
                        }
                      />
                    </td>
                    <td title={item.name}>{item?.name}</td>
                    <td title={item.label}>{item?.label}</td>
                    <td title={item.type} className="text-capitalize">{item?.type}</td>
                    <td title={item.check} className="text-capitalize">{item?.check}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
          <div className="p-2 bg-light shadow-sm hstack justify-content-end gap-2">
            <button
              onClick={updateStudyDataEntryData}
              className="border p-1 px-2 updateProfile"
            >
              Apply
            </button>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default TemplateColumnProperties;
